module.exports = __webpack_public_path__ + "static/media/ic-emailticket.1035d517.svg";